import {Template} from "../../models/Template";

let templatesApi = {
    async get(send_type, is_standard, token, companyId){
        let response = await window.axios.get('/api/templates', {
            params:{
                api_token: token,
                company_id: companyId,
                send_type: send_type,
                is_standard: is_standard
            }
        });

        //map data into model (paginated and list)
        let dataMap = data=>data.map(it=>new Template(it))
        if(response.data.current_page)
            response.data.data = dataMap(response.data.data);
        else
            response.data = dataMap(response.data);
        return response.data;
    },
    async find(id, token, companyId){
        let response = await window.axios.get('/api/templates/'+id, {
            params:{
                api_token:token,
                company_logged:companyId
            }
        });
        return new Template(response.data);
    },
    async create(template, token, companyId){
        let response = await window.axios.post('/api/templates', template, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Template(response.data);
    },
    async edit(template, token, companyId){
        let response = await window.axios.put('/api/templates/'+template.id, template, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return new Template(response.data);
    },
    async delete(template, token, companyId){
        let response = await window.axios.delete('/api/templates/'+template.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    }
}

export default templatesApi